/*
 * File: c:\Users\j.mazat\Desktop\Autobuy\AutobuyBackOffice\src\Content\Parks\Parks.tsx
 * Project: c:\Users\j.mazat\Desktop\Autobuy\AutobuyBackOffice
 * Created Date: Wednesday July 19th 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Sunday, 14th January 2024 05:04:13
 * Modified By: Simon (s.gourlet@autobuy.fr>)
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 */

import RouterPathResolver from "Config/Router/RouterPathResolver";
import translator from "MultiLanguage/TranslationWrapper";
import ParkService from "Services/ParkService/ParkService";
import { ParkType } from "Type/park.type";
import TableUtils from "Utils/TableFormat";
import Table from "Content/Table/Table";
import TitlePage from "Content/HeadingPage/TitlePage/TitlePage";
import { useState, MouseEvent, useMemo, useEffect} from "react";
import { useLoaderData } from "react-router-dom";
import ParkRow from "./ParkRow";
import ModalPark from "Content/Modals/ModalPark/ModalPark";
import SearchByTerm from "Content/Search/SearchByTerm";
import CompanyService from "Services/CompanyService/CompanyService";
// import { FixedSizeList as List } from 'react-window';

function ParksList() {
    const loadData = useLoaderData() as ParkType[];
    const keys = ["Name", "Address", "City", "PostalCode", "State", "Country", "Actions"];
    const translateKey = "table.headers.";
    const myRet = TableUtils.initFormatRowCreateHeader(keys, translateKey);
    const [showModalPark, setShowModalPark] = useState(false);
    const [updatePark, setUpdatePark] = useState<ParkType>();
    const [data, setData] = useState<ParkType[]>(loadData);
    const [result, setResult] = useState<{label: String, result: ParkType}[]>([]);

    // const handleDeletePark = async (e: any, parkID: string) => {
    //     e.stopPropagation();
    //     if (window.confirm(translator.decode("dynamic.confirmDeletePark"))){
    //         await ParkService.deletePark(parkID)
    //         .then(res => {
    //             if (res.status === 200)
    //                 window.alert(translator.decode("dynamic.deleteSuccess"));
    //         }).catch((reason: any) => {
    //             if (reason.response.status >= 400)
    //                 window.alert(translator.decode("dynamic.deleteFailed"));
    //         });
    //     }
    // };

    useEffect(() => {
        if (updatePark)
            setData([updatePark, ...data])
    }, [updatePark]);

    useEffect(() => {
        if (result.length > 0)
            setData(result.map(v => v.result));
        else
            setData(loadData);
    }, [result]);

    const handleCreatePark = (e: any) => {
        e.stopPropagation();
        setShowModalPark(true);
    };

    const handleToggleParkModal = (e: MouseEvent<HTMLElement>) => {
        setShowModalPark(false);
    };

    const buildMyRows = (data: ParkType[]) => {
        let myRows: JSX.Element[] = [];
        for (let i = 0; i < data.length; ++i)
            myRows.push(<ParkRow {...data[i]} key={`${Object.values(data[i]).filter(x => x).join(", ")}-${i}`} />);
        return myRows;
    };

    const myRows = useMemo(() => {
        return buildMyRows(data as ParkType[]);
    }, [data]);

    // const Rows = ({index, style}: {index: number, style: CSSProperties}) => {
    //     return <ParkRow style={style} {...loadData[index]} key={`${loadData[index].Name}-${index}`} />
    // };

    return(
        <div className="p-3">
            <SearchByTerm searchFunc={ParkService.getParkBySearch} setResult={setResult} title={translator.decode("dynamic.parks")} />
            <TitlePage title={translator.decode("dynamic.parks")} backLink={RouterPathResolver.pathHome.path} action={<button className="btn btn-primary" onClick={handleCreatePark}>{translator.decode("dynamic.create")}</button>}/>
            <Table cursor={false} pagination={false} rows={myRows} header={myRet.header} nbTotalElement={myRows.length} />
            <ModalPark data={{}} updatePark={setUpdatePark} submitFunc={ParkService.CreatePark} title={translator.decode("dynamic.parks")} show={showModalPark} onClose={handleToggleParkModal} closeModal={handleToggleParkModal} />
        </div>
    )
};

export default ParksList;
